import * as polished from 'polished'
import styled, { css } from 'styled-components'

import { InfoIcon } from '@nx/fire/assets'
import { Body, Heading } from '@nx/fire/typography'

export const StyledContainer = styled.div`
  ${({ theme }) => theme.fontStyles.sourceSans.regular}
  background: ${({ theme }) => polished.rgba(theme.colours.status.error, 0.1)};
  padding: 15px;
  border-radius: 5px;
`

export const StyledTitle = styled(Heading)`
  ${({ theme }) => theme.fontStyles.sourceSans.bold}
  color: ${({ theme }) => theme.colours.status.error};
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 5px;
`

export const StyledMessage = styled(Body)`
  color: ${({ theme }) => theme.colours.status.error};
  margin-bottom: 0;
`

export const StyledInfoIcon = styled(InfoIcon)`
  ${({ theme }) => css`
    border-width: 2px;
    border-style: solid;
    border-radius: 100%;
    height: 20px;
    padding: 2px;
    width: 20px;
    border-color: ${theme.colours.status.error};
    color: ${theme.colours.status.error};
  `}
`
